// Unpublished Work © 2025-2026 Deere & Company.

import {fetchWrapper} from './utils/fetch-wrapper';

export const createUserSession = (userId, applicationName) => {
    const payload = {
        userId,
        applicationName
    };

    fetchWrapper('/api/userSession', {
        body: JSON.stringify(payload),
        method: 'POST'
    });
};

const formatDate = (dateStr) => {
    if (!dateStr) {
        return '';
    }
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
};

export const downloadUserSessionReport = (startDate, endDate) =>
    fetchWrapper(
        `/api/userSession/download?startDate=${formatDate(startDate)}&endDate=${formatDate(endDate)}`,
        {
            method: 'GET'
        }
    );
